import {
  StyledIndemnitorDivider,
  StyledIndemnitorLabel,
  StyledRemoveIndemnitor,
  StyledAddIndemnitor,
  StyledAddIndemnitorButton,
  StyledIndemnitorInfo,
  StyledIndemnitorControl,
} from "./FormIndemnitor.styled";
import { StyledLeftFields } from "../FormBondApp.styled";

import { IconUser } from "../../../assets/icons/IconUser";
import { IconTrash } from "../../../assets/icons/IconTrash";
import { FormComponent } from "./Form";

export const FormIndemnitor = ({
  amountOfIndemnitor,
  isSkipBondIndemnitor,
  setFormDataBondIndemnitor,
  setAmountOfIndemnitor,
  formDataBondIndemnitor,
  submit,
  widgets,
  getLefts,
  schema,
  isLoading,
}: any) => {
  return (
    <>
      {Array(amountOfIndemnitor)
        .fill("")
        .map((_, id) => {
          const isHideSubmit = id !== amountOfIndemnitor - 1;

          return (
            <StyledIndemnitorDivider>
              {!isSkipBondIndemnitor && (
                <StyledIndemnitorControl>
                  <StyledIndemnitorInfo>
                    <IconUser />
                    <StyledIndemnitorLabel>
                      Indemnitor {id + 1} of {amountOfIndemnitor}
                    </StyledIndemnitorLabel>
                  </StyledIndemnitorInfo>
                  {id !== 0 && (
                    <StyledRemoveIndemnitor
                      onClick={() => {
                        setFormDataBondIndemnitor((data: any) =>
                          data.filter(
                            (_: any, indemnitorId: number) =>
                              id !== indemnitorId
                          )
                        );
                        setAmountOfIndemnitor((num: number) => num - 1);
                      }}
                    >
                      <IconTrash />
                      Remove
                    </StyledRemoveIndemnitor>
                  )}
                </StyledIndemnitorControl>
              )}

              <FormComponent
                isSkipBondIndemnitor={isSkipBondIndemnitor}
                setFormDataBondIndemnitor={setFormDataBondIndemnitor}
                formDataBondIndemnitor={formDataBondIndemnitor}
                submit={submit}
                widgets={widgets}
                schema={schema}
                isHideSubmit={isHideSubmit}
                id={id}
              />
              {!!getLefts(id) && !isSkipBondIndemnitor && !isHideSubmit && (
                <StyledLeftFields>
                  {getLefts(id)} required field(s) left
                </StyledLeftFields>
              )}
              {!getLefts(id) &&
                !formDataBondIndemnitor?.[id + 1] &&
                !isSkipBondIndemnitor && (
                  <StyledAddIndemnitor
                    onClick={() => {
                      setAmountOfIndemnitor((amount: number) => amount + 1);
                      setFormDataBondIndemnitor((data: any) => [...data, {}]);
                    }}
                  >
                    <StyledAddIndemnitorButton>
                      Add another indemnitor,
                    </StyledAddIndemnitorButton>
                    &nbsp;or
                  </StyledAddIndemnitor>
                )}
            </StyledIndemnitorDivider>
          );
        })}
    </>
  );
};
